<template>
	<div>
		<div id="gContent">
			<div id="aTow">
				<div id="cNav" >
					<router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<span>纸质</span>
				</div>
				<div id="lbimg"><img style="width: 100%;height: 100%;" src="../../assets/img/tout/guanc.jpg"></div>
				<div id="conList">
					<div id="wTable">
						<div id="tab1">文物名称</div>
						<div id="tab2">文物类别</div>
						<div id="tab3">文化类型</div>
					</div>
					<router-link id="oneCon" v-for="(item, index) in tableData.slice((currentPage-1)*pagesize, currentPage*pagesize)" :key="index" tag="div" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:item.collectionid,t:encodeURIComponent(item.collectionname)}}">
						<div id="navdht"></div>
						<div>
							<div class="text" style="cursor: pointer;" :id="'ww'+index" @mouseenter="hideImg(index)" @mouseleave="showImg(index)">
								{{ item.collectionname }}
								<div v-show="seen&&current==index" style="width: 150px;height: 100px;position: absolute;left: 100%;z-index: 10;top: 10px;">
					    			<img style="width: 100%;height: 100%;" :src="item.collectionimages">
					    		</div>
							</div>
							<div class="text">纸质</div>
							<div class="text">{{ item.category }}</div>
						</div>
					</router-link>
				</div>
				<el-pagination background 
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-size=pagesize
				    layout="prev, pager, next" 
					:total="tableData.length" style="margin-top: 1em;text-align:right;margin-left: 20px;margin-bottom: 1em;">
				</el-pagination>
			</div>
		</div>
		<div id="mgContent">
			<div id="maTow">
				<div id="mcNav" >
					<router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<span>纸质</span>
				</div>
				<div id="mlbimg"><img style="width: 100%;height: 100%;" src="../../assets/img/tout/guanc.jpg"></div>
				<div id="mconList">
					<div id="mwTable">
						<div id="mtab1">文物名称</div>
						<!--<div id="mtab2">质地</div>-->
						<div id="mtab3">文化类型</div>
					</div>
					<router-link id="moneCon" v-for="(item, index) in tableData.slice((currentPage-1)*pagesize, currentPage*pagesize)" :key="index" tag="div" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:item.collectionid,t:encodeURIComponent(item.collectionname)}}">
						<div id="mnavdht"></div>
						<div>
							<div class="text" style="cursor: pointer;" :id="'ww'+index" @mouseenter="hideImg(index)" @mouseleave="showImg(index)">
								{{ item.collectionname }}
								<div v-show="seen&&current==index" style="width: 150px;height: 100px;position: absolute;left: 100%;z-index: 10;top: 10px;">
					    			<img style="width: 100%;height: 100%;" :src="item.collectionimages">
					    		</div>
							</div>
							<!--<div class="text">陶瓷器</div>-->
							<div class="text">{{ item.category }}</div>
						</div>
					</router-link>
				</div>
				<el-pagination background 
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-size=pagesize
				    layout="prev, pager, next" 
					:total="tableData.length" style="margin-top: 1em;text-align:right;margin-left: 20px;margin-bottom: 1em;">
				</el-pagination>
			</div>
		</div>
	</div>
	
</template>

<script>
	import {jquery} from '@/assets/js/jquery.js'
	import qs from 'qs'
	export default{
		data(){
			return{
				tableData: [],
				loading: false,
				picArr: [],
				conLength: 0,
				myNum: 0,
				seen:false,
				current:0,
				currentPage: 1,
		        pagesize: 10
			}
		},
		mounted(){
			if(this.isMobile()){
				document.getElementById("gContent").style.display = "none";
				document.getElementById("mgContent").style.display = "block"
				this.handleSearch();
			}else{
				document.getElementById("mgContent").style.display = "none";
				document.getElementById("gContent").style.display = "block"
				this.handleSearch();
			};
			
	    },
		methods:{
			isMobile() {
		        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		        return flag;
		    },
			handleSizeChange(val) {
		        this.pagesize = val;
		    },
		    handleCurrentChange(val) {
		        this.currentPage = val;
		    },
			handleSearch(){
		        this.search();
		        let eWidth = document.body.clientWidth;
	    		document.getElementById("gContent").style.width = eWidth + "px";
	    		document.getElementById("lbimg").style.width = eWidth*0.9 + "px";
	    		document.getElementById("lbimg").style.height = eWidth*0.35 + "px";
	    		document.getElementById("aTow").style.marginLeft = (eWidth-eWidth*0.9)/2 + "px";
	    		document.getElementById("aTow").style.marginRight = (eWidth-eWidth*0.9)/2 + "px";
		    },
		    showImg:function(index){
		    	this.seen = false;
		    	this.current = null;
		    },
		    hideImg:function(index){ 
		    	this.seen = true;
		    	this.current = index;
			},
			// 查询列表
	  		search:function(){
	  			let that = this;
	  			this.HOST = 'http://www.qhmuseum.cn/qhm-webapi';
	  			let url = this.HOST + '/collection/getOnedynasty'
	  			that.loading = true;
	  			let para = {
	  				collectiondynasty:108
	  			}
	  			this.$axios.post(url, qs.stringify(para)).then(function(result){
	  				let cData = result.data;
	  				if(cData && cData.data){
	  					that.tableData = cData.data;
	  					for(let i=0;i<that.tableData.length;i++){
	  						that.picArr.push(that.tableData[i]);
	  					};
	  					that.conLength = that.picArr.length;
	  				}
	  			}).catch(function(error){
	  				console.log(err);
	  			})
	  		}
		}
	}
</script>

<style scoped>
	#gContent{
		display: none;
	}
#conList{
	margin-top: 25px;
}
#aTow>#cNav,#collCon>#cNav{
	text-align: left;
	line-height: 60px;
}
#aTow>#cNav>span:nth-child(1)
{
	cursor: pointer;
}
#aTow>#cNav>span:nth-child(1):hover
{
	color: #FF9900;
}
#wTable{
	height: 60px;
	position: relative;
	border-bottom: 1px solid #DEDEDE;
	background-color: #DEDEDE;
}
#tab1{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	left: 5%;
	font-weight: 500;
}
#tab2{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	left: 50%;
	font-weight: 500;
}
#tab3{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	right:5%;
	font-weight: 500;
}
#navdht{
	position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
}
#navdht>img{
	width: 100%;
	height: 100%;
}
#oneCon{
	height: 60px;
	border-bottom: 1px solid #e5e5e5;
	position: relative;
	text-align: left;
}
#oneCon>div>div:nth-child(1){
	position: absolute;
	line-height: 30px;
	font-size: 1em;
	top: 15px;
	left: 5%;
	padding: 0 20px 0 0;
}
#oneCon>div>div:nth-child(2){
	position: absolute;
	line-height: 30px;
	font-size: 1em;
	top: 15px;
	left: 50%;
	cursor: pointer;
}
#oneCon>div>div:nth-child(3){
	position: absolute;
	line-height: 30px;
	font-size: 1em;
	top: 15px;
	right: 5%;
	cursor: pointer;
}

#oneCon>div>.text{
	cursor: pointer;
}
#oneCon>div>.text:hover,#oneCon>div>div:nth-child(2):hover{
	color: #FF2222;
}
/*mobile*/
#mconList{
	margin-top: 25px;
}
#maTow{
	margin: auto 20px;
}
#maTow>#mcNav,#mcollCon>#mcNav{
	text-align: left;
	line-height: 60px;
}
#maTow>#mcNav>span:nth-child(1)
{
	cursor: pointer;
}
#maTow>#mcNav>span:nth-child(1):hover
{
	color: #mFF9900;
}
#mwTable{
	height: 60px;
	position: relative;
	border-bottom: 1px solid #DEDEDE;
	background-color: #DEDEDE;
}
#mtab1{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	left: 5%;
	font-weight: 500;
}
#mtab2{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	left: 50%;
	font-weight: 500;
}
#mtab3{
	position: absolute;
	line-height: 30px;
	font-size: 1.3em;
	top: 15px;
	right:5%;
	font-weight: 500;
}
#mnavdht{
	position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
}
#mnavdht>img{
	width: 100%;
	height: 100%;
}
#moneCon{
	height: 60px;
	border-bottom: 1px solid #e5e5e5;
	position: relative;
	text-align: left;
}
#moneCon>div>div:nth-child(1){
	position: absolute;
	line-height: 30px;
	font-size: 1em;
	top: 15px;
	left: 5%;
	padding: 0 20px 0 0;
}
#moneCon>div>div:nth-child(2){
	position: absolute;
	line-height: 30px;
	font-size: 1em;
	top: 15px;
	right: 5%;
	cursor: pointer;
}

#moneCon>div>.text{
	cursor: pointer;
}
#moneCon>div>.text:hover,#moneCon>div>div:nth-child(2):hover{
	color: #FF2222;
}
</style>


// WEBPACK FOOTER //
// src/pages/collection/paper.vue